module.exports = __webpack_public_path__ + "img/gallery_icon.618ade50.svg";